import { DEFAULT_TOAST_LIFE } from "../../../common/EzToast";
import {
  INIT_CUSTOMER,
  FETCH_CUSTOMER_LIST_START,
  FETCH_CUSTOMER_LIST_SUCCESS,
  FETCH_CUSTOMER_LIST_ERROR,
  FETCH_CUSTOMER_DETAIL,
  EDIT_CUSTOMER_RECORD,
  TOAST,
  CUSTOMER_CURRENCIES_PROVIDER_DD,
  CUSTOMER_COUNTRIES_PROVIDER_DD,
  DROPDOWN_TYPES,
} from "../../../constants/action-types/customer";
import { customerService } from "../../../Services";
import { goBack } from "../../../utils/gotoback";

export const initializeCustomerScreen = () => ({ type: INIT_CUSTOMER });

export const customerFetchStart = (payload) => ({
  type: FETCH_CUSTOMER_LIST_START,
  payload,
});

export const customerFetchSuccess = (payload) => ({
  type: FETCH_CUSTOMER_LIST_SUCCESS,
  payload,
});

export const customerFetchError = (payload) => ({
  type: FETCH_CUSTOMER_LIST_ERROR,
  payload,
});

export const resetToast = (payload) => ({
  type: TOAST.RESET,
  payload,
});

export const fetchCustomer = (payload) => {
  return (dispatch) => {
    dispatch(customerFetchStart(payload));
    customerService.fetchCustomer(payload).then((response) => {
      if (!response.isError) {
        dispatch(customerFetchSuccess(response));
      } else {
        dispatch(customerFetchError(response));
      }
    });
  };
};

// Fetch Customer by ID
export const fetchCustomerDetailStart = (payload) => ({
  type: FETCH_CUSTOMER_DETAIL.START,
  payload,
});

export const fetchCustomerDetailSuccess = (payload) => ({
  type: FETCH_CUSTOMER_DETAIL.SUCCESS,
  payload,
});

export const fetchCustomerDetailError = (payload) => ({
  type: FETCH_CUSTOMER_DETAIL.ERROR,
  payload,
});

export const fetchCustomerById = (id) => {
  return (dispatch) => {
    dispatch(fetchCustomerDetailStart(id));

    customerService.fetchCustomerById(id).then((data) => {
      if (!data.isError) {
        dispatch(fetchCustomerDetailSuccess(data));
      } else {
        dispatch(fetchCustomerDetailError(data));
      }
    });
  };
};

// Edit Customer Actions
export const editCustomerRecordStart = (payload) => ({
  type: EDIT_CUSTOMER_RECORD.START,
  payload,
});

export const editCustomerRecordSuccess = (payload) => ({
  type: EDIT_CUSTOMER_RECORD.SUCCESS,
  payload,
});

export const editCustomerRecordError = (payload) => ({
  type: EDIT_CUSTOMER_RECORD.ERROR,
  payload,
});

export const editCustomer = (payload) => {
  return (dispatch) => {
    dispatch(editCustomerRecordStart());

    customerService.editCustomerRecord(payload).then((data) => {
      if (!data.isError) {
        dispatch(editCustomerRecordSuccess());
      } else {
        dispatch(editCustomerRecordError(data));
      }

      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const customerCurrenciesProviderStart = (payload) => ({
  type: CUSTOMER_CURRENCIES_PROVIDER_DD.START,
  payload,
});

export const customerCurrenciesProviderSuccess = (payload) => ({
  type: CUSTOMER_CURRENCIES_PROVIDER_DD.SUCCESS,
  payload,
});

export const customerCurrenciesProviderError = (payload) => ({
  type: CUSTOMER_CURRENCIES_PROVIDER_DD.ERROR,
  payload,
});

export const fetchCustomerCurrenciesProviderDD = (payload) => {
  return (dispatch) => {
    dispatch(customerCurrenciesProviderStart(payload));

    customerService.fetchCustomerCurrenciesProviderDD(payload).then((res) => {
      if (!res.isError) {
        dispatch(customerCurrenciesProviderSuccess(res));
      } else {
        dispatch(customerCurrenciesProviderError(res));
      }
    });
  };
};

export const customerCountryProviderStart = (payload) => ({
  type: CUSTOMER_COUNTRIES_PROVIDER_DD.START,
  payload,
});

export const customerCountryProviderSuccess = (payload) => ({
  type: CUSTOMER_COUNTRIES_PROVIDER_DD.SUCCESS,
  payload,
});

export const customerCountryProviderError = (payload) => ({
  type: CUSTOMER_COUNTRIES_PROVIDER_DD.ERROR,
  payload,
});

export const fetchCustomerCountriesProviderDD = (payload) => {
  return (dispatch) => {
    dispatch(customerCountryProviderStart(payload));

    customerService.fetchCustomerCountryProviderDD(payload).then((res) => {
      if (!res.isError) {
        dispatch(customerCountryProviderSuccess(res));
      } else {
        dispatch(customerCountryProviderError(res));
      }
    });
  };
};

export const fetchDropdownStart = (type) => ({
  type: DROPDOWN_TYPES[type].START,
});

export const fetchDropdownSuccess = (type, payload) => ({
  type: DROPDOWN_TYPES[type].SUCCESS,
  payload,
});

export const fetchDropdownError = (type, payload) => ({
  type: DROPDOWN_TYPES[type].ERROR,
  payload,
});

export const fetchTypeDropdown = (type) => {
  return async (dispatch) => {
    dispatch(fetchDropdownStart(type));
    customerService.fetchTypesByCategory(type).then((res) => {
      if (!res.isError) {
        dispatch(fetchDropdownSuccess(type, res.content));
      } else {
        dispatch(fetchDropdownError(type, res));
      }
    });
  };
};
